<template>
  <div>
    <LinkTitle></LinkTitle>
    <div class="StoreWallateRecharge">
      <PageSearchTitle title="预付款详情" hideSearch="true" :showCart="false" />
      <!-- <div class="StoreWallateRechargeTitle">
      <el-page-header @back="goBack" content=""> </el-page-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'moneyManage' }"
          ><span class="titleText">财务管理</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'prepayRecharge' }"
          ><span class="titleText">预付款</span></el-breadcrumb-item
        >
      </el-breadcrumb>
      </div>-->
      <div class="cardWidth">
        <el-card class="box-card">
          <div slot="header">
            <div
              class="clearfix"
              :style="{width:(this.isShow1 ? '430px' : '180px')}"
            >我的预付款充值（本{{this.userInfo.storeId? '店铺':'人'}}在其他店铺充值的预付款）</div>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="myStoreShow"
            >{{ this.isShow1 ? "收起" : "展开" }}</el-button>
          </div>
          <div class="textitem">
            <el-table
              :data="myStoreChargeList"
              stripe
              :style="{width:(this.isShow1 ? '600px' : '230px')}"
              height="400"
            >
              <el-table-column prop="store_name" label="用户" align="center" width="120"></el-table-column>
              <el-table-column
                prop="ass_bal"
                label="冻结"
                v-if="this.isShow1"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column
                prop="avl_bal"
                label="解锁"
                v-if="this.isShow1"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column prop="balance" align="center" width="110" label="余额"></el-table-column>
              <el-table-column align="center" width="150" v-if="this.isShow1" label="功能">
                <template slot-scope="scope">
                  <el-button
                    type="success"
                    size="mini"
                    round
                    @click="dialogVisibleLock(scope.row)"
                  >解锁</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    round
                    @click="dialogVisibleRecharge(scope.row)"
                  >充值</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisiblelo"
          width="30%"
          :close-on-click-modal="false"
          :show-close="false"
        >
          <div class="dialogStore">
            <span>{{ this.storeName }}将在您执行解锁操作后拥有使用解锁金额的权力，确认继续？</span>
          </div>
          <el-input placeholder="请输入解锁金额(元)" v-model="lockInput"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleloCancel">取 消</el-button>
            <el-button type="primary" @click="unlockRecharge">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisiblePassword"
          width="30%"
          :close-on-click-modal="false"
          :show-close="false"
          :before-close="handleCloselo"
        >
          <el-input placeholder="请输入密码" v-model.number="passwordInput" type="password"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisiblePassword = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisiblePasswordInput">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="预付款充值"
          :visible.sync="dialogVisiblere"
          width="30%"
          :close-on-click-modal="false"
          :show-close="false"
          :before-close="handleClosere"
        >
          <el-radio-group v-model="selectLock" @change="selectLockChange">
            <el-radio :label="0">本次解锁</el-radio>
            <el-radio :label="1">不解锁</el-radio>
            <el-radio :label="2">自动解锁</el-radio>
          </el-radio-group>
          <div class="dialogStore">{{this.storeName}}</div>
          <el-input
            placeholder="请输入充值金额"
            v-model="rechargeInput"
            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)"
            onafterpaste="this.value=this.value.match(/\d+\.?\d{0,2}/)"
          >
            <template slot="prepend">预付款充值额度 :</template>
            <template slot="append">元</template>
          </el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisiblereCancel">取 消</el-button>
            <el-button type="primary" @click="RechangeMoney">确 定</el-button>
          </span>
        </el-dialog>

        <el-card class="box-card" v-if="this.listShow">
          <div slot="header">
            <span>已收个人的预付款充值</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="personalShow"
            >{{ this.isShow2 ? "收起" : "展开" }}</el-button>
          </div>
          <div class="textitem">
            <el-table
              :data="personalChangeList"
              stripe
              :style="{width:(this.isShow2 ? '450px' : '230px')}"
              height="400"
            >
              <el-table-column prop="user_nickName" label="用户" align="center" width="120"></el-table-column>
              <el-table-column
                prop="ass_bal"
                label="冻结"
                v-if="this.isShow2"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column
                prop="avl_bal"
                label="解锁"
                v-if="this.isShow2"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column prop="balance" align="center" width="110" label="余额"></el-table-column>
            </el-table>
          </div>
        </el-card>
        <el-card class="box-card" v-if="this.listShow">
          <div slot="header">
            <span>已收其他店铺的预付款充值</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="storeShow"
            >{{ this.isShow3 ? "收起" : "展开" }}</el-button>
          </div>
          <div class="textitem">
            <el-table
              :data="storeChargeList"
              stripe
              :style="{width:(this.isShow3 ? '450px' : '230px')}"
              height="400"
            >
              <el-table-column prop="user_nickName" label="用户" align="center" width="120"></el-table-column>
              <el-table-column
                prop="ass_bal"
                label="冻结"
                v-if="this.isShow3"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column
                prop="avl_bal"
                label="解锁"
                v-if="this.isShow3"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column width="110" prop="balance" align="center" label="余额"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import { mapState, mapActions } from "vuex";
import {
  storeWithdraw,
  storeBanList,
  usList,
  custlist,
  addPrepay,
  getUSBySId,
  isNewRechargeUser,
  avalRecharge
} from "@/api/api";
export default {
  name: "StoreWallateRecharge",
  data() {
    return {
      listShow: false,
      personalChangeList: [],
      storeChargeList: [],
      myStoreChargeList: [],
      storeChargeList1: [],
      isShow1: true,
      isShow2: false,
      isShow3: false,
      selectLock: 0,
      lockInput: "",
      rechargeInput: "",
      passwordInput: "",
      storeName: "",
      storeId: "",
      isNewUser: "",
      dialogVisiblere: false,
      dialogVisiblelo: false,
      dialogVisiblePassword: false,
      withDrawalcardList: null,
      formInfo2: {
        visible: false,
        info: ""
      },
      storeWithdrawalForm: {
        money: "",
        phone: ""
      },
      cardList: [],
      selectedBank: null
    };
  },
  components: { PageSearchTitle },
  computed: {
    ...mapState(["userInfo", "companyInfo"])
  },
  created() {
    // this.myStoreCharge();
    // this.personalCharge();
    // this.storeCharge();
    // console.log(this.userInfo)
    this.ceshi();
  },
  methods: {
    addWithdrawalCard() {
      // this.$alert("添加提现银行卡");
      // return;
      if (this.companyInfo && this.companyInfo.type != 9) {
        //非养殖户
        if (this.companyInfo.type == 3) {
          //下挂店铺提现
          this.$router.push("childStoreWidthDrawalCard");
        } else {
          //普通企业提现
          this.$router.push("storeAddWidthDrawalCard");
        }
      } else {
        this.$alert("养殖户绑卡请于肉联所app内操作");
      }
    },

    ceshi() {
      if (this.userInfo.storeId) {
        this.myStoreCharge();
        this.personalCharge();
        this.storeCharge();
        this.listShow = true;
      } else {
        this.listShow = false;
        this.personalCharge();
        console.log("aaaaaaaaaaaaa");
      }
    },
    myStoreCharge() {
      let access_token = this.userInfo.access_token;
      let url = storeBanList;
      let data = {
        pageSize: 999,
        access_token
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: encodeURI(param),
        url
      })
        .then(res => {
          // console.log(res);
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            // if (data && data.length && !isBeijing) {
            //   // alert(1)
            //   data = data.filter((item) => {
            //     return item.storeName.indexOf("中农亿家") < 0;
            //   });
            // }
            console.log("dataf", data);
            this.myStoreChargeList = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },
    personalCharge() {
      let access_token = this.userInfo.access_token;
      let url = usList;
      let data = {
        pageSize: 999,
        access_token
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: encodeURI(param),
        url
      })
        .then(res => {
          // console.log(res);
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            if (this.userInfo) {
              // alert(1)
              // data = data.filter((item) => {
              //   return item.storeName.indexOf("中农亿家") < 0;
              // });
              this.personalChangeList = data;
            } else {
              this.myStoreChargeList = data;
            }
            console.log("dataf", data);
            this.personalChangeList = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },
    storeCharge() {
      let access_token = this.userInfo.access_token;
      let url = getUSBySId;
      let data = {
        pageSize: 999,
        access_token
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: encodeURI(param),
        url
      })
        .then(res => {
          // console.log(res);
          if (res.data.resultCode == 1) {
            let { data } = res.data;

            this.storeChargeList = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },

    myStoreShow() {
      if (this.isShow1 == true) {
        this.isShow1 = false;
      } else {
        this.isShow2 = false;
        this.isShow3 = false;
        this.isShow1 = true;
      }
    },
    personalShow() {
      if (this.isShow2 == false) {
        this.isShow1 = false;
        this.isShow3 = false;
        this.isShow2 = true;
      } else {
        this.isShow2 = false;
        this.isShow1 = true;
      }
    },
    storeShow() {
      if (this.isShow3 == false) {
        this.isShow1 = false;
        this.isShow2 = false;
        this.isShow3 = true;
      } else {
        this.isShow3 = false;
        this.isShow1 = true;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    handleClosere(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.rechargeInput = "";
          this.selectLock = 0;
        })
        .catch(_ => {});
    },
    handleCloselo(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.lockInput = "";
        })
        .catch(_ => {});
    },
    dialogVisibleRecharge(row) {
      console.log(row);
      this.storeName = row.store_name;
      this.storeId = row.store_id;
      this.dialogVisiblere = true;
    },
    dialogVisibleLock(row) {
      this.storeName = row.store_name;
      this.storeId = row.id;
      this.dialogVisiblelo = true;
    },
    unlockRecharge() {
      this.dialogVisiblelo = false;
      let access_token = this.userInfo.access_token;
      let url = isNewRechargeUser;
      let data = {
        // pageSize: 999,
        access_token
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            // console.log("dataf", data);
            this.isNewUser = data;
            if (this.isNewUser == false) {
              this.dialogVisiblePassword = true;
            }
            console.log(this.isNewUser);
          } else {
            // this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },
    dialogVisiblePasswordInput() {
      let access_token = this.userInfo.access_token;
      let url = avalRecharge;
      // console.log('this.passwordInput',this.passwordInput)
      // console.log('this.$md5(String(this.passwordInput))',this.$md5(String(this.passwordInput)))
      let data = {
        access_token,
        id: this.storeId,
        money: this.lockInput,
        payPwd: this.$md5(String(this.passwordInput))
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            console.log("dataf", data);
            this.passwordInput = "";
            this.$alert(res.data.resultMsg);
            this.myStoreCharge();
          } else {
            this.$alert(res.data.resultMsg);
            this.passwordInput = "";
          }
        })
        .catch(err => {
          // this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
      this.dialogVisiblePassword = false;
      this.myStoreCharge();
    },
    selectLockChange() {
      console.log(this.selectLock);
    },
    dialogVisiblereCancel() {
      this.dialogVisiblere = false;
      this.rechargeInput = "";
    },
    dialogVisibleloCancel() {
      this.dialogVisiblelo = false;
      this.lockInput = "";
    },

    RechangeMoney() {
      if (this.rechargeInput > 0) {
        let access_token = this.userInfo.access_token;
        let url = addPrepay;
        let data = {
          access_token,
          store_id: this.storeId,
          money: this.rechargeInput,
          isLock: this.selectLock
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url
        })
          .then(res => {
            if (res.data.resultCode == 1) {
              let { data } = res.data;
              console.log("dataf", data);
              let id = data.id;
              let order_id = data.order_id;
              let totalMoney = data.totalMoney;
              let prepayment = data.prepayment;
              let type = data.type;
              let fm_status = data.fm_status;
              let pay_flag = data.pay_flag;
              let store_name = data.store_name;
              let store_id = data.store_id;
              this.$router.push({
                name: "payPage",
                query: {
                  id,
                  order_id,
                  totalMoney,
                  prepayment,
                  type,
                  fm_status,
                  pay_flag,
                  store_name,
                  store_id
                }
              });
            } else {
              this.$alert(res.data.resultMsg);
            }
          })
          .catch(err => {
            // this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
          });
        console.log("mckmkmc");
        // this.dialogVisiblere=false;
      } else {
        this.$alert("充值金额无效");
      }
    },
    formateTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    }
  }
};
</script>

<style scoped lang='less'>
.StoreWallateRecharge {
  padding: 0 100px 20px;
  height: 95%;
  min-width: 1300px;
  margin-top: 10px;
}
.StoreWallateRecharge .cardWidth {
  width: 95%;
  height: 95%;
  padding: 10px;
  display: flex;
}
.StoreWallateRecharge .cardWidth .box-card {
  height: 80%;
  margin-top: 50px;
  display: inline-block;
  margin-left: 20px;
  /* flex: 1; */
}
.titleText {
  font-size: 13px;
  color: #009e96 !important;
}
// .StoreWallateRechargeTitle {
//   display: flex;
//   flex-direction: row;
//   align-items: center;
// }
.dialogStore {
  margin-top: 20px;
  margin-bottom: 20px;
  /* button{
    float: right;
    color: #409eff;
    margin-right: 30px;
    margin-top: 3px;
    background-color: #fff;
  } */
}
.dialogStore button {
  float: right;
  color: #409eff;
  margin-right: 30px;
  margin-top: 3px;
  background-color: #fff;
}
.clearfix {
  display: inline-block;
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/prepayRecharge/PrepayRecharge.vue